// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';
import TrainingDetailComponent from '../../components/trainings/training-detail/training-detail';
import { isMobileOnly } from 'react-device-detect';
import { Link } from 'react-router-dom';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';

// Prime react imports
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';

// Styling
import './trainings.scss';

// Redux
import { connect } from 'react-redux';
import TrainingService from '../../redux/services/training';

// Utils
import { getPrettyDatetime } from '../../common/utils/date-utils';
import { TRAINING_AREA_CONGRESS } from '../../common/constants';

class TrainingsPage extends Component {

    constructor(props) {    
        super(props);
        this._toast = React.createRef();
        this.state = {
            selectedTraining: null,
            trainings: []
        };
    }

    componentDidMount() {
        TrainingService.getActiveTrainings(this.props.associate.associateId)
        .then((response) => {
            let trainings = [];

            for (let i = 0; i < response.trainings.length; i++) {
                // Filter out congresses since it has a dedicated page
                if(response.trainings[i].trainingAreaId !== TRAINING_AREA_CONGRESS) {
                    trainings.push(response.trainings[i]);
                }
            }

            this.setState({
                trainings: trainings
            });
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("trainings.messages.error"), life: 3000 });
        });
    }

    checkTrainingAvailability(trainingRef) {
        if(this.props.basketTrainings !== undefined) {
            for (let i = 0; i < this.props.basketTrainings.length; i++) {
                if(this.props.basketTrainings[i].trainingRef === trainingRef) {
                    return false;
                }            
            }   
        }

        return true;
    }

    addTrainingToBasketCallback() {
        this.setState({
            selectedTraining: null
        });

        window.scrollTo(0, 0);
        window.open(process.env.PUBLIC_URL + "/checkout", "_self")
        this._toast.current.show({ severity: 'success', detail: this.props.t("products.messages.product-added"), life: 3000 });
    }

    getTrainingSubtitleData(training) {
        return <div className="grid mgt-20">
                    <div className="col-12 t-align-left">
                        <i className="pi pi-globe mgr-10" style={{fontSize:"1.2rem"}}></i>
                        <span style={{fontSize:"1.2rem"}}>{training.place}</span>
                    </div>
                    <div className="col-12 t-align-left">
                        <i className="pi pi-calendar mgr-10" style={{fontSize:"1.2rem"}}></i>
                        <span style={{fontSize:"1.2rem"}}>{getPrettyDatetime(training.trainingStartDate)}</span>
                    </div>
                    <div className="col-12 t-align-left">
                        <i className="pi pi-stopwatch mgr-10" style={{fontSize:"1.2rem"}}></i>
                        <span style={{fontSize:"1.2rem"}}>{this.props.t("trainings.labels.duration")} {training.duration.totalHours}</span>
                    </div>
                </div>;
    }

    render() {
       return (
            <div>
                <div>
                {
                    localStorage.getItem('Hideinapp') === "1" ?
                        <div className="grid" style={{minHeight:"60px", alignItems:"center", background: "#0073AA", textAlign: "left"}}>
                            <div className="col-1"></div>
                            <div className="col-6">
                                <span style={{color:"#FFFFFF", fontSize:"18px"}}>{this.props.t("trainings.title")}</span>
                            </div>
                            <div className="col-4 t-align-right" style={{paddingRight: "20px"}}>
                                <Link to={process.env.PUBLIC_URL + "/checkout"}>
                                    {
                                        this.props.basketProducts.length === 0 ?
                                            <i className="pi pi-shopping-cart c-pointer" style={{ color: "#ffffff", fontSize: '1.9rem' }} title={this.props.t("checkout.menu")}></i>
                                            :
                                            <i className="pi pi-shopping-cart p-overlay-badge c-pointer" style={{ color: "#ffffff", fontSize: '1.9rem' }} title={this.props.t("checkout.menu")}>
                                                <Badge style={{ borderColor: "#ffffff" }} value={this.props.basketTrainings.length}></Badge>
                                            </i>
                                    }
                                </Link>
                            </div>
                            <div className="col-1"></div>
                        </div>
                        :
                        <PageTitleComponent title={this.props.t("trainings.title")} />
                }
        </div>
        <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
            <div className='col-1'></div>
            <div className="col-10"> 
                <div className='grid container mgt-20'>
                    <div className="col-12 md:col-12 lg:col-12 t-align-right">
                        <Button label={this.props.t("trainings.labels.view-all")} icon="pi pi-file" className="logout-btn c-pointer" onClick={() => window.open(process.env.PUBLIC_URL + "/training-registrations", "_self")} />
                    </div>
                    { 
                        this.state.trainings.map((training) => {
                            return (
                                    <div key={training.trainingRef} className="col-12 md:col-6 lg:col-4">
                                        <Card style={{color: "#0073aa", display: "flex", flexWrap: "wrap", alignContent: "space-between", flexDirection: "column", minHeight: "250px"}} 
                                            title={training.title} 
                                            subTitle={this.getTrainingSubtitleData(training)} 
                                            footer={ <div className='grid'>
                                                            <div style={{paddingTop: "15px"}} className='col-5 t-align-left'>
                                                                <b style={{fontSize: "16px", marginTop: "10px", marginLeft: "10px"}}>{training.price === null ? this.props.t("trainings.labels.free") : training.price + "€"}</b>
                                                            </div>
                                                            <div className='col-7 t-align-right'>
                                                                <div className="flex flex-wrap justify-content-end gap-2">
                                                                    <Button label={this.props.t("trainings.labels.more-info")} icon="pi pi-info-circle" disabled={!this.checkTrainingAvailability(training.trainingRef)} onClick={(evt) => this.setState({selectedTraining: training})} />
                                                                </div>
                                                            </div>
                                                        </div>} 
                                            header={<img alt="Card" src={"data:image/jpeg;base64," + training.cardImg} style={{maxHeight:"200px"}} />} 
                                            className="md:w-25rem">
                                        </Card>
                                    </div>
                            );
                        })
                    }
                </div>  
                <div className='grid container mgt-20'>
                {
                    this.state.trainings.length > 0 ? 
                        <div className="col-12 md:col-12 lg:col-12 t-align-center">
                            { /* <Button className='p-button-success' style={{fontSize: "20px"}} label={this.props.t("checkout.messages.close-registration")} onClick={() => window.open(process.env.PUBLIC_URL + "/checkout", "_self")}  /> */ }
                        </div>
                        : 
                        <div className="col-12 md:col-12 lg:col-12 t-align-center">
                            <p style={{fontSize:"14px"}}>{this.props.t("trainings.messages.no-trainings")}</p>
                        </div>
                }
                </div>
            </div>
            <div className='col-1'></div>
        </div>
        <Dialog visible={this.state.selectedTraining !== null} style={{ width: '850px' }} header={this.state.selectedTraining ? this.state.selectedTraining.title : null} modal onHide={() => this.setState({selectedTraining: null}) }>
            <TrainingDetailComponent training={this.state.selectedTraining} onClose={() => this.addTrainingToBasketCallback()} />
        </Dialog>
        <Toast position='bottom-left' ref={this._toast} />
    </div>
);
    }
}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        ballot: state.profile.ballot,
        basketProducts: state.store.basketProducts,
        basketTrainings: state.store.basketTrainings
    } 
};

export default connect(mapStateToProps, undefined)(authenticationChecker(withTranslation(TrainingsPage)));